export enum SidebarTabEnum {
  PopupManagement = 'popup_management',
  PagesManagement = 'pages_management',
  WebsiteStylesSettings = 'website_styles_settings',
  PageEditing = 'page_editing',
  WebsiteSettings = 'website_settings',
}

export enum PageActionsEnum {
  Settings = 'settings',
  Publish = 'publish',
  Remove = 'remove',
}
